module.exports = __webpack_public_path__ + "img/intro_scientist.32241647.svg";